/* eslint-disable react/jsx-closing-tag-location */
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

import { Tooltip } from 'antd';
import './style.css';

class BasicInputField extends Component {
	constructor(props) {
		super(props);
		this.inputRef = React.createRef();
	}

	handleClick = () => {
		if (this.inputRef.current) {
			this.inputRef.current.focus();
		}
	};

	setCursor = () => {
		const textfield = document.getElementById('phone-mask');
		textfield.value = textfield.value.replace(/[\u2000]/g, '');
	};

	TextMaskCustom = props => {
		const { ...other } = props;
		return (
			<MaskedInput
				{...other}
				id="phone-mask"
				keepCharPositions
				mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
				onFocus={this.setCursor}
				placeholderChar={'\u2000'}
			/>
		);
	};

	render() {
		return (
			<FormControl variant="outlined">
				<div className="common-basic-input-wrapper" onClick={this.handleClick}>
					{this.props.toolTip ? (
						<Tooltip arrow title={this.props.toolTip}>
							<input
								maxLength={this.props.maxLength}
								disabled={this.props.disabled}
								value={this.props.value}
								onChange={this.props.onChange}
								className={`common-basic-input ${this.props.className}`}
								placeholder={this.props.label}
								ref={this.inputRef}
								name={`${this.props.name || 'phone'}`}
							/>
						</Tooltip>
					) : (
						<input
							maxLength={this.props.maxLength}
							disabled={this.props.disabled}
							value={this.props.value}
							onChange={this.props.onChange}
							className={`common-basic-input ${this.props.className}`}
							placeholder={this.props.label}
							ref={this.inputRef}
							name={`${this.props.name || 'phone'}`}
						/>
					)}
				</div>
				{this.props.error ? <FormHelperText id="text-red">{this.props.helperText}</FormHelperText> : ''}
			</FormControl>
		);
	}
}

export default BasicInputField;
